var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSection3T2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.772949,
    y: 0.60791,
    width: 42.5553,
    height: 43.5047,
    rx: 2.007,
    fill: "#C63100"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5718 23.0649H16.1304C15.9619 23.0649 15.8252 23.2189 15.8252 23.4086V29.5947C15.8252 29.7844 15.9619 29.9384 16.1304 29.9384H18.5718C18.7402 29.9384 18.877 29.7844 18.877 29.5947V23.4086C18.877 23.2189 18.7402 23.0649 18.5718 23.0649Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9551 19.7654L23.7296 14.7826C23.5962 14.6249 23.3131 14.6249 23.1796 14.7826L18.9542 19.7654C18.8696 19.8651 18.8531 20.0016 18.9115 20.1169C18.9704 20.2321 19.0939 20.3052 19.2292 20.3052H21.694V29.6064C21.694 29.7898 21.8518 29.9386 22.0461 29.9386H24.8631C25.0575 29.9386 25.2153 29.7898 25.2153 29.6064V20.3052H27.6801C27.8153 20.3052 27.9389 20.2321 27.9974 20.1169C28.0562 20.0019 28.0396 19.8651 27.9551 19.7654Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection3T2);
export default __webpack_public_path__ + "static/media/section3t2.2675288ddb78a02de71c10cab123081b.svg";
export { ForwardRef as ReactComponent };